import { createContext, ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import * as Sentry from '@sentry/react'
import { saveLocale } from '../../helpers/utils'
import { getMe } from '../../http'
import { getUserLanguage } from '../../Http/general'
import { Queries } from '../../queries'
import { UserStore } from '../../store/User/UserStore'
import { CenteredSpinner } from '../Common/Spinner'
interface IMainLayoutContext {
  user: UserStore
  sidebar: {
    hidden: boolean
    setHidden: (...args: any[]) => any
    toggle: () => any
  }
  header: {
    title?: string
    updateTitle: (node: ReactNode) => any
    clear: () => any
  }
  permission: number
}

export const MainLayoutContext = createContext<IMainLayoutContext>(undefined)

export const MainLayoutContextProvider = ({ children }) => {
  const [sidebarHidden, setSidebarHidden] = useState(true)
  const [headerTitle, setHeaderTitle] = useState()
  const { i18n, t } = useTranslation()
  const query = useQuery(Queries.ME, getMe, { enabled: !location.href.includes('public') })
  const { data: language } = useQuery([Queries.USER_LANGUAGE], () => getUserLanguage(), { enabled: !!query?.data })
  const providerValue: IMainLayoutContext = {
    user: query.data ? new UserStore(query.data) : null,
    header: {
      title: headerTitle,
      updateTitle: setHeaderTitle,
      clear: () => setHeaderTitle(null),
    },
    sidebar: {
      hidden: sidebarHidden,
      setHidden: setSidebarHidden,
      toggle: () => setSidebarHidden(!sidebarHidden),
    },
    permission: query.data?.permissionValue,
  }
  useEffect(() => {
    if (language) {
      saveLocale(language)
      i18n.changeLanguage(language)
    }
  }, [language])
  useEffect(() => {
    if ('FreshworksWidget' in window && providerValue.user) {
      const { firstName, lastName, email } = providerValue.user.data
      window.FreshworksWidget('identify', 'ticketForm', {
        name: `${firstName} ${lastName}`,
        email,
      })
      window.FreshworksWidget('disable', 'ticketForm', ['name', 'email'])
    }
    if (providerValue.user) {
      const { firstName, lastName, email, userId } = providerValue.user.data
      Sentry.setUser({ email: email, username: `${firstName} ${lastName}`, id: userId })
    }
  }, [providerValue])

  return (
    <MainLayoutContext.Provider value={providerValue}>
      {query.isLoading ? <CenteredSpinner /> : providerValue && children}
    </MainLayoutContext.Provider>
  )
}
